/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Settings_Status_Plc_DisconnectedInputs */



/**
* | output |
* | --- |
* | "PLC disconnected" |
*
* @param {Module_Settings_Status_Plc_DisconnectedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_settings_status_plc_disconnected = /** @type {((inputs?: Module_Settings_Status_Plc_DisconnectedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Settings_Status_Plc_DisconnectedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("PLC disconnected")
	return /** @type {LocalizedString} */ ("Automate déconnecté")
});